<template>
    <div>
        <v-text-field 
            autocomplete="off"
            :label="label"
            :value="textVal"
            @input="setValue"
            :background-color="computedError||error?'#ff9898':'#ffffff'"
            :disabled="disabled"
        />
        
    </div>
</template>

<script>
var moment = require('moment');
    export default {
        name:'DateWidget',
        props:{
            value:String,
            label:String,
            disabled: {
                type: Boolean,
                default: false,
            },
            error: {
                type: Boolean,
                default: false,
            }
        },
        data(){
            return {
                textVal:undefined,
                parsedVal:undefined,
            }
        },
        mounted(){
            this.setValue(moment(this.value,'YYYY-MM-DD').format('DD/MM/YYYY'))
        },
        methods:{
            setValue(newVal){
                this.textVal=newVal
                let formated=moment(newVal,'DD/MM/YYYY').format('YYYY-MM-DD')
                // console.log(newVal.length)
                if(formated!='Invalid date' && newVal.length>=8){
                    this.parsedVal=formated
                }else{
                    this.parsedVal=undefined
                }
                this.$emit('input',this.parsedVal)
            },
            isValidDate(d_str){
                let res = false
                try{
                    let d_str_split = d_str.split('-')
                    let d = new Date(d_str_split[1]+'/'+d_str_split[2]+'/'+d_str_split[0])
                    // console.log(d)
                    if (!isNaN(d.getTime())){
                    res = true
                    }
                    if(d_str_split[0].length!=4 || d_str_split[1].length!=2 || d_str_split[2].length!=2){
                        res = false
                    }
                }
                catch(err){
                    res = false
                }
                return res
            },
        },
        computed:{
            computedError(){
                let error = !this.isValidDate(this.value)
                return error
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>